/**
 * The 6 meal slots. nutrition_logs.meal_slot is always one of these STABLE keys;
 * the label is the client's display name (renameable) and is fetched per-user
 * from GET /api/nutrition/meal-labels. Renaming never touches logged food.
 */

export const MEAL_SLOT_KEYS = [
  'meal_1',
  'meal_2',
  'meal_3',
  'meal_4',
  'meal_5',
  'meal_6',
] as const;

export type MealSlotKey = (typeof MEAL_SLOT_KEYS)[number];

export function defaultMealLabel(key: string): string {
  return `Meal ${key.replace('meal_', '')}`;
}

/** Merge stored labels over the Meal 1–6 defaults. */
export function withDefaults(labels: Record<string, string> | undefined): Record<string, string> {
  const out: Record<string, string> = {};
  for (const key of MEAL_SLOT_KEYS) out[key] = labels?.[key] || defaultMealLabel(key);
  return out;
}
